import { render, staticRenderFns } from "./ExportDossiers.vue?vue&type=template&id=92beaea6&scoped=true"
import script from "./ExportDossiers.vue?vue&type=script&lang=js"
export * from "./ExportDossiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92beaea6",
  null
  
)

export default component.exports